import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { Student } from 'src/app/model/student/student.model';
import { CalpadSSIDResoultion } from '../../../service/calpad-ssid-resolution';
import { ShortDateTime } from 'src/app/pipes/short-date-time';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';




const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();

interface CalpadsStudentIndex {
  ID: number;
  CALPADS_STUDENT_ID: number;
  INDEX: number;
  MODIFIED_BY: string;
  MODIFIED_DATE: string;
  RESPONSE: string;
}


@Component({
  selector: 'app-unresolved-match-task',
  templateUrl: './unresolved-match-task.component.html',
  styleUrl: './unresolved-match-task.component.scss'
})
export class UnresolvedMatchTaskComponent implements OnInit, AfterViewInit {

  // use template reference variables to distinguish the two MatSort instances
  @ViewChild('mainTableSort') sort!: MatSort;
  @ViewChild('sinfTableSort') sortSinf!: MatSort;

  @ViewChild('sinfPaginator') sinfPaginator!: MatPaginator;
  isProcessing = false;
  msg: MsgModel = {};
  isLoading = true;

  idx: CalpadsStudentIndex[] = [];

  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'top';


  displayedColumnsSinf = [
    'Match',
    'Name',
    'SSID',
    'DOB',
    'Gender',
    'Birth City',
    'CurrentSchoolDistrict',
    'Current Grade',
    'Guardian1',
    'Guardian2'
  ];

  displayedColumns = [
    'MSD Number',
    'Name',
    'SSID',
    'DOB',
    'Gender',
    'Birth City',
    'CurrentSchoolDistrict',
    'Current Grade',
    'Guardian1',
    'Guardian2'
  ];

  tableDataSource = new MatTableDataSource<Student>();
  tableDataSourceSinf = new MatTableDataSource<Student>();
  regionCode: string | null = '';
  studentId: string | null = '';
  student: Student = new Student();
  studentLen: number = 0;

  checked = false;
  fromDate: Date | null = null;
  toDate: Date | null = null;

  maxDate = new Date(); // Today
  msdNumber: string;
  CurrentSSID: string;
  selectedSSID: string;
  sinfCalpadStudentIndexId: string;


  constructor(
    private calpadSSIDResolution: CalpadSSIDResoultion,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<UnresolvedMatchTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {
    //this.regionCode = this.route.snapshot.paramMap.get('code');
    console.log(this.route.snapshot.paramMap)
    this.studentId = data.ID;
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    // assign sorts and paginators once the view children are available
    this.tableDataSource.sort = this.sort;

    this.tableDataSourceSinf.paginator = this.sinfPaginator;
    this.tableDataSourceSinf.sort = this.sortSinf;

  }

  // this handler is no longer necessary; sorts are bound via ViewChild and
  // updated after data is loaded. kept for compatibility with template binding
  setupSorting(sortState: Sort) {

    this.tableDataSourceSinf.sort = this.sortSinf;
  }

  private loadData(): void {
    this.msg = new MsgModel();

    this.calpadSSIDResolution
      .getStudentInfo(this.studentId!)
      .subscribe(res => {

        if (res?.student) {
          this.msg.SUCCESS = true;
          let results: Student[] = [];
          results = Array.isArray(res?.student) ? res.student : [res.student];
          this.CurrentSSID = res?.student?.SSID || '';
          const filteredResults = results.filter(element => {
            return (
              element.PERSON?.LAST_NAME ||
              element.PERSON?.FIRST_NAME
            );
          });

          this.tableDataSource = new MatTableDataSource<Student>(filteredResults);
          this.tableDataSource.sort = this.sort;


          this.tableDataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'Name':
                return [
                  item.PERSON?.LAST_NAME || '',
                  item.PERSON?.SECOND_LAST_NAME || '',
                  item.PERSON?.FIRST_NAME || ''
                ].join(' ').toLowerCase();
              case 'SSID':
                return item.SSID || '';
              case 'DOB':
                return item.DOB ? new ShortDateTime('en-US').transform(item.DOB, 'short') || '' : '';
              case 'Gender':
                return item.SEX ? item.SEX : '';
              case 'Birth City':
                return item.BIRTH_CITY ? item.BIRTH_CITY : '';
              case 'CurrentSchoolDistrict':
                return item.SCHOOL?.DISTRICT ? item.SCHOOL?.DISTRICT : '';
              case 'CurrentGrade':
                let grade = "";
                // item?.Senr?.GradeLevelCode ? item?.Senr?.GradeLevelCode  : '';
                return grade;
              case 'Guardian1':
                let guardian1: string = "";
                //guardian1 = item?.Senr.Guardian1FirstName ? item?.Senr.Guardian1FirstName  : '';
                return guardian1;
              case 'Guardian2':
                let guardian2: string = "";
                // guardian2 = item?.Senr.Guardian2FirstName ? item?.Senr.Guardian2FirstName  : '';
                return guardian2;
              default:
                return (item as any)[property];
            }
          };

          // now get sinf data

        }
        else {
          this.msg.SUCCESS = false;
          this.msg.MSG = 'No Records Found.';
          this.isLoading = false;
        }
      });

    this.calpadSSIDResolution
      .GetUnresolvedStudent(this.studentId!)
      .subscribe(res2 => {
        this.student = res2?.student;

        this.msdNumber = res2?.student?.STUDENT.MSD_NUMBER || '';
        const indexes = res2?.student?.CALPADS_STUDENTS_INDEXES;

        this.studentLen = indexes.length;
        let results: Student[] = [];
        indexes.forEach((idx: CalpadsStudentIndex) => {

          const responseObj = JSON.parse(idx.RESPONSE);
          const sinf = responseObj?.Sinf;
          
          sinf['CALPADS_STUDENT_INDEX_ID'] = idx.ID;
          sinf['CALPADS_STUDENT_ID'] = idx.CALPADS_STUDENT_ID;
          this.sinfCalpadStudentIndexId = idx.CALPADS_STUDENT_ID.toString();
          if (Array.isArray(sinf)) {
            results = results.concat(sinf);
          } else if (sinf) {
            results.push(sinf);
          }

          const filteredResults = results.filter(element => {
            return (
              element.StudentLegalFirstName ||
              element.StudentLegalLastName
            );
          });
          this.tableDataSourceSinf = new MatTableDataSource<Student>(filteredResults);
          // reapply sort and paginator after we update the data source
          this.tableDataSourceSinf.paginator = this.sinfPaginator;
          this.tableDataSourceSinf.sort = this.sortSinf;

          this.isLoading = false;

          this.tableDataSourceSinf.sortingDataAccessor = (item: Student, property) => {
            const firstStudent = item;
            console.log('Sorting by property:', property, 'for student:', firstStudent);
            switch (property) {
              case 'Name':
                return [
                  firstStudent.StudentLegalLastName || '',
                  firstStudent.StudentLegalFirstName
                ].join(' ').toLowerCase();
              case 'SSID':
                return firstStudent.Ssid || '';
              case 'DOB':
                return firstStudent.StudentBirthDate ? new ShortDateTime('en-US').transform(firstStudent.StudentBirthDate, 'short') || '' : '';
              case 'Gender':
                return firstStudent.StudentGenderCode ? firstStudent.StudentGenderCode : '';
              case 'Birth City':
                return firstStudent.StudentBirthCity ? firstStudent.StudentBirthCity : '';
              case 'CurrentSchoolDistrict':
                return firstStudent.SCHOOL?.DISTRICT ? firstStudent.SCHOOL?.DISTRICT : '';
              case 'CurrentGrade':
                let grade = "";
                return grade;
              case 'Guardian1':
                let guardian1: string = "";
                guardian1 = [firstStudent.Guardian1LastName || '', firstStudent.Guardian1FirstName].join(' ').toLowerCase();
                return guardian1;
              case 'Guardian2':
                let guardian2: string = "";
                guardian2 = [firstStudent.Guardian2LastName || '', firstStudent.Guardian2FirstName].join(' ').toLowerCase();
                return guardian2;
              default:
                return (item as any)[property];
            }
          };
        });


      });
  }
  selectMatch(row: any, type: string = 'Match') {
    // show gray overlay and spinner while processing the match
    this.isProcessing = true;

    if (type === 'No Match') {
      //this.tableDataSourceSinf.data[0]. = '';
      this.calpadSSIDResolution.resolveNoMatch(
        this.studentId!, this.sinfCalpadStudentIndexId)
        .subscribe(res => {
          if (res['msg']) {
            this.msg = res['msg'];
            this.msg.SUCCESS = true;
            this.msg.MSG = 'Match saved successfully.Redirecting...';
            setTimeout(() => {
              this.isProcessing = false;
              this.closeRecord(true);
            }, 1000);
          }
          else {
            this.isProcessing = false;
            this.msg = new MsgModel();
            this.msg.MSG = 'Failed to save the match. Please try again.';
            this.msg.SUCCESS = false;

          }
        });
    }
    else {
      this.selectedSSID = row.Ssid;
      this.calpadSSIDResolution.resolveSSID(
        this.studentId!, row.CALPADS_STUDENT_ID, row.CALPADS_STUDENT_INDEX_ID, row.Ssid)
        .subscribe(res => {
          if (res['msg']) {
            this.msg = res['msg'];
            this.msg.SUCCESS = true;
            this.msg.MSG = 'Match saved successfully.Redirecting...';
            setTimeout(() => {
              this.isProcessing = false;
              this.closeRecord(true);
            }, 2000);
          }
          else {
            this.isProcessing = false;
            this.msg = new MsgModel();
            this.msg.MSG = 'Failed to save the match. Please try again.';
            this.msg.SUCCESS = false;

          }
        });
    }
  }
  selectNoMatch() {
    this.selectMatch(this.tableDataSourceSinf.data[0], 'No Match');
  }
  cancelMatch()
  {
    this.selectedSSID='';
  }
  getPopoverMsg(row: any): string {
    if(row == null) {
      this.selectedSSID = '';
      return '<span style="font-size:20px;"><b>No SSID is selected. This will resolve as "No Match".</b></span>';
    }
    else if (this.CurrentSSID == row.Ssid) {
      this.selectedSSID = row.Ssid;
      return '<span style="font-size:20px;"> <b> The selected SSID (' + row.Ssid + ') <br> is the same as the current SSID (' + this.CurrentSSID + '). </b></span>';
    }
    else if (this.CurrentSSID && row.Ssid) {
      this.selectedSSID = row.Ssid;
      return '<span style="font-size:20px;"><b>The selected SSID (' + row.Ssid + ') will replace the current SSID (' + this.CurrentSSID + '). </b></span>';
    }
    else if (this.CurrentSSID && !row.Ssid) {
      return '<span style="font-size:20px;"><b>No SSID is selected. This will resolve as "No Match" and the current SSID (' + this.CurrentSSID + ') will be removed.</b></span>';
    }
    else if (!this.CurrentSSID && row.Ssid) {
      this.selectedSSID = row.Ssid;
      return '<span style="font-size:20px;"><b>This child will be resolved with the selected SSID (' + row.Ssid + ').</b></span>';
    }
    else {
      this.selectedSSID = row.Ssid;
      return '<span style="font-size:20px;"><b>This child will be resolved with the selected SSID (' + row.Ssid + ').</b></span>';
    }

  }
  displayNames(element: any): string {
    const legalLastName = this.nullToEmpty(element.StudentLegalLastName);
    const aliasLastName = this.nullToEmpty(element.StudentAliasLastName);
    const legalFirstName = this.nullToEmpty(element.StudentLegalFirstName);
    const legalMiddleName = this.nullToEmpty(element.StudentLegalMiddleName);

    let names = legalLastName;
    if (aliasLastName) names += ` ${aliasLastName}`;
    if (legalFirstName) names += `, ${legalFirstName}`;
    if (legalMiddleName) names += ` ${legalMiddleName}`;
    return names.trim();
  }

  nullToEmpty(inStr: string): string {
    if (!inStr) return '';
    return inStr.toLowerCase().includes('null') ? '' : inStr.trim();
  }

  closeRecord(refresh: boolean = false) {
    this.dialogRef.close(refresh);
  }
}

